import { ajaxPreloader, callMeAjax } from "../../../../../../../public/rubberduck/dist/lib/rubberduck/callMeAjax.build.js";
import { gaSendTagForm } from "../../../../google/dist/js/google_analytics_form.js";
import { viewport } from "../../../../../../../public/rubberduck/dist/js/utils.js";

// TODO: bundle check recaptcha variable

export function QuackFormHandler(options) {
    /**
     * @ajax_selector
     * Selector for the form that will be submitted with Ajax
     * 
     * @no_ajax_selector
     * Selector for the form that will be submitted with default behavior
     */
    this._options = options;
    if (this._options.ajax_selector == undefined || this._options.ajax_selector == '') {
        this._options.ajax_selector = 'form.ajax';
    }
    if (this._options.no_ajax_selector == undefined || this._options.no_ajax_selector == '') {
        this._options.no_ajax_selector = 'form.no_ajax';
    }
    $('body').on('submit', this._options.ajax_selector + ', ' + this._options.no_ajax_selector, function(e) {
        e.preventDefault();
        let form = e.currentTarget;
        if (typeof ajaxPreloader === 'function') {
            ajaxPreloader();
        }
        if (typeof recaptcha !== 'undefined') {
            recaptcha.addEvent(form).then(function(f) {
                if ($(form).is(this._options.ajax_selector)) {
                    this._ajaxSubmit(f);
                } else if ($(form).is(this._options.no_ajax_selector)) {
                    this._submit(f);
                }
            }.bind(this));
        } else {
            if ($(form).is(this._options.ajax_selector)) {
                this._ajaxSubmit(form);
            } else if ($(form).is(this._options.no_ajax_selector)) {
                this._submit(form);
            }
        }
    }.bind(this));
    $('body').on('click', '.redBox .close_wrapper', function() {
        $(this).closest('.redBox').slideUp(function () {
            $(this).remove();
        });
    });

    this._ajaxSubmit = function(form) {
        if (typeof callMeAjax !== 'function') {
            return this._submit(form);
        }
        this._GATag(form).then(function() {
            $('.redBox').remove();
            let formData = new FormData(form);
            callMeAjax($(form).attr('action'), formData, $(form).attr('data-callback')).done(function(data) {
                let ga_data = {
                    formTitle: data.form_title
                };
                window.dataLayer = window.dataLayer || [];
                if (data.status == 'error' && typeof data.box_message !== 'undefined') {
                    $(form).prepend(data.box_message);
                    $('html,body').animate({
                        scrollTop: $(form).offset().top - (viewport().height / 4)
                    }, 'slow');
                    ga_data.event = 'FormSubmissionFailed';
                    ga_data.errorMessage = data.error_messages;
                } else {
                    ga_data.event = 'FormSubmissionSucceded';
                    ga_data.errorMessage = null;
                }
                if ($(form).attr('data-gaformtag') != undefined) {
                    ga_data.form_custom_tag = $(form).attr('data-gaformtag');
                }
                window.dataLayer.push(ga_data);
            });
        }.bind(this));
    }

    this._submit = function(form) {
        this._GATag(form).then(function() {
            $('body').off('submit', this._options.ajax_selector + ', ' + this._options.no_ajax_selector);
            // Can't trigger submit if there is a submit input
            $(form).find('input[type="submit"]').remove();
            $(form).submit();
        }.bind(this));
    }

    this._GATag = async function(form) {
        if (typeof gaSendTagForm !== 'undefined') {
            return new Promise(function (resolve, reject) {
                gaSendTagForm(form).then(async function() {
                    resolve(true);
                });
            });
        }
    }
}